import { render, staticRenderFns } from "./conversation-add-box.vue?vue&type=template&id=fe266d58&scoped=true&"
import script from "./conversation-add-box.vue?vue&type=script&lang=js&"
export * from "./conversation-add-box.vue?vue&type=script&lang=js&"
import style0 from "./conversation-add-box.vue?vue&type=style&index=0&id=fe266d58&prod&lang=less&scoped=true&"
import style1 from "./conversation-add-box.vue?vue&type=style&index=1&id=fe266d58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe266d58",
  null
  
)

export default component.exports